// Vuex
import store from '@/store.js';

import Request from './request';

// 获取地址
async function select(data) {
    var newData = Object.assign({
        disabled: [0, 1],
    }, data);
    return Request('get',
        'api/cities/city-select/',
        newData,
        true)
}

// 获取全部地址映射
async function fetchMap() {
    if (
        !store.state.citiesMapTime ||
        new Date().getTime() - store.state.citiesMapTime > 60 * 60 * 24 * 1000
    ) {
        const response = await Request('get', "api/cities");
        if (response.data && response.data.status.isOK()) {
            store.commit("citiesMap", response.data.cities);
        }
        return response;
    }
}

// 获取省市树形结构
async function cities() {
    return Request('get', "api/cities/provinceCitytree");
}


export default {
    select,
    fetchMap,
    cities
}
